import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

import { LeftCategoryNavigation } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/LeftCategoryNavigation";
import { useCurrentCategoryModel } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";

export const CategoryPageSidebar = () => {
  const selectedCategory = useCurrentCategoryModel();

  const viewport = useViewport();

  if (viewport.isMobile || viewport.isTablet) {
    return null;
  }

  return <LeftCategoryNavigation selectedCategory={selectedCategory} />;
};
